import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurytempotraveleronrentinpune() {



  const cardData = {
"keyword": "Luxury Tempo Traveller On Rent in Pune",

"headingDescription":
  "Shivai Travels offers premium Luxury Tempo Traveller on rent in Pune for comfortable group travel including family tours, corporate outings, wedding transportation, pilgrimage journeys, airport transfers, and outstation trips across Maharashtra and India. Our luxury Tempo Traveller fleet is designed to provide a smooth and premium travel experience with spacious pushback reclining seats, powerful air conditioning, ambient lighting, music system, charging points, and ample luggage space for long-distance journeys. Ideal for 9–17 passengers, our vehicles ensure a safe, comfortable, and relaxing ride even on highways and ghat roads. With experienced professional drivers, well-maintained luxury vehicles, flexible rental packages, doorstep pickup and drop, and 24/7 customer support, Shivai Travels ensures a reliable and hassle-free group travel experience from Pune.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for waterfalls, scenic valleys, forts, and monsoon views, making them ideal for luxury Tempo Traveller group trips."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description":
      "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, lakes, and cool climate, perfect for comfortable luxury group travel from Pune."
  },
  {
    "title": "Goa",
    "description":
      "Goa is a top long-distance travel destination from Pune known for beaches, nightlife, water sports, and resorts, ideal for luxury Tempo Traveller road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by devotees using luxury Tempo Traveller services from Pune for group darshan trips."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik and Trimbakeshwar are spiritual and wine tourism destinations known for temples, vineyards, and religious journeys, ideal for luxury group travel."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and resorts, making it a popular luxury weekend destination from Pune."
  },
  {
    "title": "Konkan Beaches (Murud, Kashid, Ganpatipule)",
    "description":
      "Konkan beaches offer scenic coastal drives, clean beaches, and peaceful surroundings, perfect for luxury group road trips in Tempo Travellers."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites known for ancient rock-cut architecture and cultural tourism experiences."
  },
  {
    "title": "Mumbai City Tour",
    "description":
      "Mumbai is a major metro destination known for Marine Drive, Gateway of India, shopping areas, and business hubs, ideal for luxury group travel from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, modern architecture, and peaceful surroundings, perfect for short luxury group getaways."
  }
],



services: [
  {
    name: "Luxury Tempo Traveller Pune",
    description: "Luxury Tempo Traveller Pune service provides premium and spacious transportation for airport transfers, family trips, corporate travel, sightseeing tours, weddings, and outstation journeys. Luxury Tempo Traveller vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, music systems, and luggage space suitable for executive and family travel requirements. Flexible booking options allow convenient luxury Tempo Traveller reservations in Pune."
  },
  {
    name: "Premium Tempo Traveller Pune",
    description: "Premium Tempo Traveller Pune service offers dependable transportation solutions for travelers seeking comfortable group travel within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient premium Tempo Traveller reservations."
  },
  {
    name: "Luxury Traveller Hire Pune",
    description: "Luxury traveller hire Pune service provides affordable and comfortable executive travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury traveller hire reservations."
  },
  {
    name: "AC Luxury Tempo Traveller Pune",
    description: "AC luxury Tempo Traveller Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient AC luxury Tempo Traveller reservations."
  },
  {
    name: "Cheap Luxury Traveller Pune",
    description: "Cheap luxury traveller Pune service offers economical and comfortable transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, airport transfers, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable luxury traveller reservations."
  },
  {
    name: "Outstation Luxury Tempo Traveller Pune",
    description: "Outstation luxury Tempo Traveller Pune service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation luxury Tempo Traveller reservations."
  },
  {
    name: "Airport Luxury Traveller Pune",
    description: "Airport luxury traveller Pune service offers spacious transportation for airport transfers, family tours, corporate outings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and executive travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport luxury traveller reservations."
  },
  {
    name: "Luxury Traveller Booking Pune",
    description: "Luxury traveller booking Pune service provides reliable transportation for airport pickup and drop services from Pune Airport and nearby locations. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury traveller booking reservations."
  },
  {
    name: "Luxury Traveller One Way Pune",
    description: "Luxury traveller one way Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient one-way luxury traveller reservations."
  },
  {
    name: "Luxury Traveller Round Trip Pune",
    description: "Luxury traveller round trip Pune service offers spacious and comfortable transportation for one-side and return travel from Pune to nearby cities and tourist destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient round trip luxury traveller reservations."
  },
  {
    name: "Best Luxury Traveller Pune",
    description: "Best luxury traveller Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient best luxury traveller reservations."
  },
  {
    name: "Luxury Traveller with Driver Pune",
    description: "Luxury traveller with driver Pune service offers reliable group transportation for airport pickup and drop services, sightseeing tours, and outstation travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury traveller with driver reservations."
  },
  {
    name: "VIP Tempo Traveller Pune",
    description: "VIP Tempo Traveller Pune service provides complete luxury transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient VIP Tempo Traveller reservations."
  },
  {
    name: "Family Luxury Traveller Pune",
    description: "Family luxury traveller Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family luxury traveller reservations."
  },
  {
    name: "Luxury Group Travel Pune",
    description: "Luxury group travel Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, airport travel, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury group travel reservations."
  }
],

tableData: [
  ["Luxury Tempo Traveller Pune", "Premium Tempo Traveller Pune"],
  ["Luxury Traveller Hire Pune", "AC Luxury Tempo Traveller Pune"],
  ["Cheap Luxury Traveller Pune", "Outstation Luxury Tempo Traveller Pune"],
  ["Airport Luxury Traveller Pune", "Luxury Traveller Booking Pune"],
  ["Luxury Traveller One Way Pune", "Luxury Traveller Round Trip Pune"],
  ["Best Luxury Traveller Pune", "Luxury Traveller with Driver Pune"],
  ["VIP Tempo Traveller Pune", "Family Luxury Traveller Pune"],
  ["Luxury Group Travel Pune", "Luxury Tempo Traveller Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Luxury Tempo Traveller on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Luxury Tempo Traveller rental service in Pune with professional drivers, premium seating, and punctual pickup for smooth and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Affordable Luxury Tempo Traveller Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Luxury Tempo Traveller on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Luxury Tempo Traveller Availability",
        WhyChoosedescription: "Our Luxury Tempo Traveller rental service in Pune operates 24 hours a day for corporate travel, weddings, airport transfers, family tours, pilgrimage trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Premium & Comfortable AC Tempo Travellers",
        WhyChoosedescription: "All Luxury Tempo Travellers provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained with pushback seats and luxury interiors for premium travel comfort."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Luxury Tempo Traveller booking, round-trip travel, airport transfers, sightseeing tours, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 12 seater, 13 seater, 17 seater, 20 seater, and Maharaja Luxury Tempo Travellers suitable for families, corporate groups, tourists, and wedding travel."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Luxury Group Tours",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, hill stations, Konkan roads, and interstate destinations, ensuring safe driving and smooth luxury travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Luxury Tempo Traveller rental service in Pune?", answer: "Luxury Tempo Traveller rental service in Pune provides premium group transportation for family tours, corporate outings, weddings, airport transfers, and outstation journeys." },
    { question: "Is Luxury Tempo Traveller on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Luxury Tempo Traveller rental service in Pune." },
    { question: "Which seating options are available in Luxury Tempo Travellers?", answer: "Shivai Travels offers 9 seater, 12 seater, 13 seater, 17 seater, and 20 seater Luxury Tempo Travellers." },
    { question: "Can I book Luxury Tempo Traveller for outstation travel?", answer: "Yes, customers can book Luxury Tempo Travellers for local sightseeing, airport transfers, corporate travel, and outstation tours." },
    { question: "Do you provide one-way and round-trip Luxury Tempo Traveller service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Luxury Tempo Traveller booking services." },
    { question: "Are all Luxury Tempo Travellers air-conditioned?", answer: "Yes, all Luxury Tempo Travellers are fully air-conditioned and maintained for comfortable premium travel." },
    { question: "Can I book Luxury Tempo Traveller on rent in Pune online?", answer: "Yes, customers can easily book Luxury Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Luxury Tempo Travellers for weddings and corporate events?", answer: "Yes, Shivai Travels provides Luxury Tempo Travellers for weddings, corporate outings, VIP travel, and family group transportation." },
    { question: "What is the starting per km rate for Luxury Tempo Traveller in Pune?", answer: "Luxury Tempo Traveller rental rates in Pune generally start from ₹22 to ₹38 per kilometer depending on seating capacity and luxury configuration." },
    { question: "Is advance booking available for Luxury Tempo Traveller rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Luxury Tempo Traveller on rent in Pune with Shivai Travels. Premium vehicle, smooth journey, and excellent driver support for our corporate trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Luxury Tempo Traveller rental service in Pune. Affordable pricing, clean luxury vehicle, and wonderful premium group travel experience.",
      rating: 5
    }
  ];


  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Tempo Traveller on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/luxury-tempo-traveller-pune.jpg",
  "description": "Book Luxury Tempo Traveller on rent in Pune with Shivai Travels for premium, comfortable and spacious group travel. Ideal for family trips, corporate travel, weddings, airport transfers, and outstation journeys. Available with AC, VIP seating, professional driver, and flexible booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹25/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/luxury-tempo-traveller-pune"
  }
};






  return (
    <div>


<Helmet>
  <title>Luxury Tempo Traveller on Rent in Pune | VIP Group Travel Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Luxury Tempo Traveller in Pune with Shivai Travels. VIP premium group travel cab for family trips, corporate travel, weddings, airport transfers, and outstation journeys. Available 24x7 with driver."
  />

  <meta
    name="keywords"
    content="luxury tempo traveller pune, premium tempo traveller pune, luxury traveller hire pune, ac luxury tempo traveller pune, cheap luxury traveller pune, outstation luxury tempo traveller pune, airport luxury traveller pune, luxury traveller booking pune, luxury traveller one way pune, luxury traveller round trip pune, best luxury traveller pune, luxury traveller with driver pune, vip tempo traveller pune, family luxury traveller pune, luxury group travel pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurytempotraveleronrentinpune;